// Generated by GitHub Copilot
/**
 * Centralized privilege helper functions
 * These helpers consolidate privilege checks to ensure consistency across the application
 */

/**
 * Check if user has editor privilege
 * @param {Object} user - User object with privileges
 * @returns {boolean} - True if user has editor privilege
 */
export const hasEditorAccess = (user) => {
  return user?.privileges?.editor === true;
};

/**
 * Check if user has a specific privilege
 * @param {Object} user - User object with privileges
 * @param {string} privilege - Privilege name to check
 * @returns {boolean} - True if user has the privilege
 */
export const hasPrivilege = (user, privilege) => {
  return user?.privileges?.[privilege] === true;
};

/**
 * US1971073: Check if user may hard-delete a reported impact.
 * Restricted to the MIM/Eternium persona (impact_delete) or deity.
 * @param {Object} user - User object with privileges
 * @returns {boolean} - True if user may delete an impact
 */
export const canDeleteImpact = (user) => {
  return hasPrivilege(user, 'impact_delete') || hasPrivilege(user, 'deity');
};

/**
 * US2163904: Check if user may attach, replace or remove an incident's Exec Summary Slide
 * and Document links. Restricted to Eternium (incident_artifact_edit) or deity. The server enforces
 * the same rule; this only decides whether to show the control.
 * @param {Object} user - User object with privileges
 * @returns {boolean} - True if user may change an incident's links
 */
export const canEditIncidentArtifacts = (user) => {
  return hasPrivilege(user, 'incident_artifact_edit') || hasPrivilege(user, 'deity');
};
